import React, { createContext, useContext, useEffect, useState } from 'react';
import socket from './custom-socket';

const SocketContext = createContext();

export const useSocket = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
    const [isSocketConnected, setIsSocketConnected] = useState(false);
    
    useEffect(() => {
        console.log(socket);
        
        const handleSocketConnected = () => {
            setIsSocketConnected(true);
        };

        const handleSocketDisconnected = () => {
            setIsSocketConnected(false);
        };

        socket.on('socket-connected', handleSocketConnected);
        socket.on('socket-dis-connected', handleSocketDisconnected);
        socket.on('disconnect', handleSocketDisconnected);
        socket.on('connect', handleSocketConnected);

        return () => {
            socket.off('socket-connected', handleSocketConnected);
            socket.off('socket-dis-connected', handleSocketDisconnected);
            socket.off('disconnect', handleSocketDisconnected);
            socket.off('connect', handleSocketConnected);
        };
    }, [socket]);

    return (
        <SocketContext.Provider
            value={{ socket, isSocketConnected }}
        >
            {children}
        </SocketContext.Provider>
    );
};
